// extracted by mini-css-extract-plugin
export default {"mCard":"gC-z","image":"hC-z","imageNoBackground":"iC-z","imageHasCategory":"jC-z","fullWidth":"kC-z"};